import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { DffSideModule, PanelModule } from "@dffedb/ui";

import { PrognoseRoutingModule } from "./prognose-routing.module";
import { PrognoseComponent } from "./prognose.component";

@NgModule({
    imports: [CommonModule, DffSideModule, PanelModule, PrognoseRoutingModule],
    declarations: [PrognoseComponent],
    providers: []
})
export class EForsyningFeaturesPrognoseModule {}
